import { logInfo } from '@core/logging'
import { getBrowser, getOS } from '@core/userAgent'

declare global {
  interface Window {
    fwnLockManager: LockManager
  }
}

/**
 * Polyfills the Web Locks API for Safari and browsers without support.
 *
 * Modern Safari does support Web Locks, but as of June 8 2023 this bug still
 * appears to be in Safari 16.5 https://bugs.webkit.org/show_bug.cgi?id=239614.
 *
 * @returns The LockManager interface
 */
export async function getLockManager() {
  if (getBrowser() === 'Safari' || getOS() === 'iOS' || !navigator.locks) {
    if (window.fwnLockManager) {
      return window.fwnLockManager
    }
    const module = await import('web-locks-polyfill/make-locks-request')
    const makeLocksRequest = module.default
    window.fwnLockManager = {
      request: makeLocksRequest({
        // eslint-disable-next-line zeffo/no-window-storage
        storage: localStorage,
        outerPrefix: 'fw_mut_out_lock_',
        innerPrefix: 'fw_mut_in_lock_',
        // The default lockTimeout of the library is 2000. This means after a
        // page reload the page will not be able to reaquire a lock for 2s. We
        // are choosing a shorter time here to speed up appeared performance.
        lockTimeout: 500,
      }),
      query: () => {
        logInfo('navigator.locks.query is not supported by this polyfill')
        return new Promise(() => ({}))
      },
    }
    return window.fwnLockManager
  } else {
    return navigator.locks
  }
}
